import { createContext, useContext } from 'react';
import { useAuth } from 'providers/AuthProvider';

const PrivacyContext = createContext({
  privateMode: false,
  unlockPrivate: () => {},
  lockPrivate: () => {}
});

export const usePrivacy = () => useContext(PrivacyContext);

export const PrivacyProvider = ({ children }) => {
  const {
    isPrivateUnlocked,
    unlockPrivate,
    lockPrivate
  } = useAuth();

  return (
    <PrivacyContext.Provider
      value={{
        privateMode: isPrivateUnlocked,
        unlockPrivate,
        lockPrivate
      }}
    >
      {children}
    </PrivacyContext.Provider>
  );
};